import React, { PropsWithChildren } from 'react'

import styled from 'styled-components'

import { variables } from 'src/Styled/variables'

const StyledLink = styled.a`
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-size: ${variables.fontSize14};
  font-style: normal;
  font-weight: ${variables.fontWeight400};
  line-height: 150%;
  cursor: pointer;
  text-decoration: none;
  border-bottom: 1px dashed ${({ theme }) => theme.color.darkGrey};

  &:hover {
    color: ${({ theme }) => theme.color.darkGrey};
    border-bottom: 1px dashed transparent;
    &:active {
      color: ${({ theme }) => theme.color.darkGrey};
    }
  }

  &:focus {
    border-bottom: none;
    outline: none;
    color: ${({ theme }) => theme.color.darkGrey};
  }

  &:active {
    color: ${({ theme }) => theme.color.darkGrey};
    border-bottom: 1px solid ${({ theme }) => theme.color.darkGrey};
  }

  &:visited {
    color: ${({ theme }) => theme.color.darkGrey};
    text-decoration: none;
  }
`

export type DottedLinkProps = PropsWithChildren &
  React.AnchorHTMLAttributes<HTMLAnchorElement>

export const DottedLink: React.FC<DottedLinkProps> = ({
  children,
  ...props
}) => <StyledLink {...props}>{children}</StyledLink>
